module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feed pb-5"
  }, _vm._l((_vm.cards), function(card) {
    return (_vm.filter == card.category || _vm.filter == 'today') ? _c('div', [(card.visible) ? _c('dashboard-feedcard' + card.type, {
      tag: "div",
      attrs: {
        "cardInfo": card
      }
    }) : _vm._e()], 1) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dc04e6f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Feed.vue
// module id = 2187
// module chunks = 0